import React from 'react';
import {connect} from 'react-redux';
import {SelectInput} from 'react-admin';
import {useTranslation} from 'react-i18next';

// Only meaningful for contact_updated drips — the API returns 400 for any other trigger,
// so the field is hidden and the saga drops the value for the other trigger types.
const DripCampaignWatchAttribute = ({triggerType, attributes, dispatch, ...props}) => {
    const {t} = useTranslation();

    if ('contact_updated' !== triggerType) {
        return null;
    }

    const choices = [
        {'@id': '', name: t('Any change')},
        ...attributes.map(attribute => ({'@id': attribute['@id'], name: attribute.name})),
    ];

    return (
        <SelectInput
            {...props}
            source="watchAttribute"
            label={t('Listen to field')}
            choices={choices}
            optionText="name"
            optionValue="@id"
            helperText={t('Only a change to this field starts the campaign.')}
            fullWidth
        />
    );
};

const mapStateToProps = (state) => ({
    triggerType: state.dripCampaign.dripCampaign.triggerType,
    attributes: state.campaign.wizard.attributes.data,
});

export default connect(mapStateToProps)(DripCampaignWatchAttribute);
